import { AnyAction } from '@reduxjs/toolkit'
import { has } from 'lodash'

import {
  FETCH_PUBLISHER_ANALYTICS_SUCCESS,
  FETCH_PUBLISHER_NOTIFICATION_LOGS_SUCCESS,
  FETCH_PUBLISHER_NOTIFICATION_SUCCESS,
  FETCH_SYSTEM_CONNECTOR_ACTIVITY_SUCCESS,
  RESET_CSV_URLS
} from './actionTypes'

type SpacePublisherLogsPageState = {
  deviceMetrics?: unknown[]
  publisherMetrics?: unknown
  generatedCSVUrls: any
  notification?: any
  previousPublisherMetrics?: unknown
}

const initialState: SpacePublisherLogsPageState = {
  deviceMetrics: [],
  publisherMetrics: {},
  generatedCSVUrls: {},
  notification: {}
}

export default function NotificationReducer(state = initialState, action: AnyAction): SpacePublisherLogsPageState {
  switch (action.type) {
    case FETCH_PUBLISHER_ANALYTICS_SUCCESS: {
      return {
        ...state,
        deviceMetrics: action.response.requestedPeriod
      }
    }

    case FETCH_SYSTEM_CONNECTOR_ACTIVITY_SUCCESS: {
      return {
        ...state,
        publisherMetrics: action.response.requestedPeriod[0],
        previousPublisherMetrics: has(action.response, 'previousPeriod') ? action.response.previousPeriod[0] : undefined
      }
    }
    case FETCH_PUBLISHER_NOTIFICATION_LOGS_SUCCESS: {
      return {
        ...state,
        generatedCSVUrls: action.response
      }
    }
    case FETCH_PUBLISHER_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        notification: action.response
      }
    }
    case RESET_CSV_URLS: {
      return {
        generatedCSVUrls: initialState.generatedCSVUrls
      }
    }

    default: {
      return state
    }
  }
}
